function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArrowDown = function SvgArrowDown(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), React.createElement("g", null, React.createElement("g", {
    transform: "translate(50 50) scale(0.69 0.69) rotate(0) translate(-50 -50)",
    style: {
      fill: "#000000"
    }
  }, React.createElement("svg", _extends({
    fill: "#000000",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), React.createElement("g", {
    transform: "translate(0,-952.36218)"
  }, React.createElement("path", {
    d: "m 50.005264,1024.3622 c 0.715,-0.028 1.5414,-0.3223 2.0626,-0.8125 l 17.00076,-16 c 0.9743,-1.0842 1.3765,-3.1632 0.25,-4.375 -1.1095,-1.1936 -3.2613,-1.1581 -4.3752,0.031 l -11.9381,11.25 0,-31.09355 c 0,-1.6568 -1.34316,-3 -3.00006,-3 -1.6569,0 -3.0001,1.3432 -3.0001,3 l 0,31.09355 -11.9381,-11.25 c -1.0255,-1.0237 -3.253,-1.2129 -4.3752,-0.031 -1.1221,1.1816 -0.7636,3.3353 0.2501,4.375 l 17.0007,16 c 0.5818,0.5475 1.2644,0.8143 2.0626,0.8125 z",
    style: {
      textIndent: 0,
      textTransform: "none",
      direction: "ltr",
      blockProgression: "tb",
      baselineShift: "baseline",
      color: "#000000",
      enableBackground: "accumulate"
    },
    fill: "#000000",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    marker: "none",
    visibility: "visible",
    display: "inline",
    overflow: "visible"
  }))))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgArrowDown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-down.dba5949b.svg";
export { ForwardRef as ReactComponent };